<template>
	<div>
		<div class="m-4 flex flex-col lg:flex-row mb-8">
			<div class="w-full lg:w-1/2">
				<BaseInput
					ref="BaseInput1"
					:label="$t('recipient') + ' (' + receiverType + ')'"
					v-model="value.receiver"
					:required="true"
					validationtype="email"
				/>
				<BaseInput ref="BaseInput2" :label="$t('subject')" v-model="value.subject" :required="true" />
				<BaseInput ref="BaseInput3" :label="$t('text')" v-model="value.text" :required="true" style="height: 440px;">
					<textarea v-model="value.text" class="h-full" />
				</BaseInput>
				<div class="text-left">
					<div class="font-bold">
						{{ $t('appendix') }} <span class="text-sm text-gray-500">{{ $t('if_set') }}</span>
					</div>
					<div v-for="attachment in attachments" :key="attachment">
						<font-awesome-icon :icon="['fas', 'angle-right']" class="mr-1"></font-awesome-icon>
						{{ attachment }}
					</div>
					<div v-if="Object.keys(attachments).length === 0">
						{{ $t('none') }}
					</div>
				</div>
			</div>

			<div class="xl:w-1/2 h-230" v-if="pdfURL">
				<div class="flex justify-center">
					<PDFThumbnailPreview :pdf-u-r-l="pdfURL" :autoreload="true" :type="pdfType" :uuid="uuid" />
				</div>
			</div>
		</div>

		<div class="text-right mx-4 my-4">
			<BaseButton @click="$emit('cancelMail')" class="mr-2">{{ $t('general.cancel') }}</BaseButton>
			<BaseButton @click="save" class="btn-blue">{{ $t('send_mail_to', { type: receiverType }) }}</BaseButton>
		</div>
	</div>
</template>

<script>
import BaseInput from '@/components/forms/inputs/BaseInput';
import BaseButton from '@/components/forms/buttons/BaseButton';
import Validate from '@/mixins/Validate';
import PDFThumbnailPreview from '@/components/damagecases/forms/PDFThumbnailPreview';
export default {
	name: 'DunningMailLawyer',
	components: { PDFThumbnailPreview, BaseButton, BaseInput },
	mixins: [Validate],
	props: {
		value: {},
		pdfURL: null,
		attachments: {},
		receiverType: null,
		pdfType: {},
		uuid: { default: '' },
	},
	data() {
		return {};
	},
	methods: {
		save() {
			if (!this.validate()) {
				this.$swal(this.$t('general.error').toString(), this.$t('please_check_input').toString(), 'error');
				return false;
			}
			this.$emit('sendMail');
		},
	},
};
</script>
